import * as React from "react";
import { Collapse, Slider, Input, Switch } from "antd";
import styled from "styled-components";
import { ChromePicker } from "react-color";
import update from "immutability-helper";
import { ThemeContext } from "../../../../themeDesigner";

const Panel = Collapse.Panel;

const Label = styled.label`
  font-family: Muli;
  font-size: 13px;
  font-weight: 600;
  color: #7f90af;
  display: block;
  margin-bottom: 8px;
`;

const SettingRow = styled.div`
  margin-bottom: 16px;
`;

const ColorPickerWrapper = styled.div`
  margin-bottom: 8px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  input {
    flex: 1;
  }
`;

export default function SuggestionsProperties() {
  const { themeProps, setThemeProps } = React.useContext(ThemeContext);
  const suggestions = themeProps.widget.modernUIStyles.suggestions;

  const handleUpdate = (key: string, value: any) => {
    const numValue = typeof value === "number" ? value : (Array.isArray(value) ? value[0] : value);
    const updated = update(themeProps, {
      widget: {
        modernUIStyles: {
          suggestions: {
            [key]: { $set: numValue },
          },
        },
      },
    });
    setThemeProps(updated);
  };

  return (
    <Collapse defaultActiveKey={["1"]}>
      <Panel header="Suggestion Pill Styles" key="1">
        <SettingRow>
          <Label>Border Radius (px)</Label>
          <Wrapper>
            <Input
              type="number"
              value={suggestions.borderRadius}
              onChange={(e) =>
                handleUpdate("borderRadius", parseInt(e.target.value) || 20)
              }
              min={0}
              max={50}
            />
            <span>{suggestions.borderRadius}px</span>
          </Wrapper>
          <Slider
            value={suggestions.borderRadius}
            onChange={(val) => handleUpdate("borderRadius", val)}
            min={0}
            max={50}
            step={1}
            style={{ marginTop: "8px" }}
          />
        </SettingRow>

        <SettingRow>
          <Label>Shadow Blur (px)</Label>
          <Wrapper>
            <Input
              type="number"
              value={suggestions.shadowBlur}
              onChange={(e) => handleUpdate("shadowBlur", parseInt(e.target.value) || 4)}
              min={0}
              max={50}
            />
            <span>{suggestions.shadowBlur}px</span>
          </Wrapper>
          <Slider
            value={suggestions.shadowBlur}
            onChange={(val) => handleUpdate("shadowBlur", val)}
            min={0}
            max={50}
            step={1}
            style={{ marginTop: "8px" }}
          />
        </SettingRow>

        <SettingRow>
          <Label>Shadow Color</Label>
          <ColorPickerWrapper>
            <ChromePicker
              color={{
                r: suggestions.shadowColor.r,
                g: suggestions.shadowColor.g,
                b: suggestions.shadowColor.b,
                a: suggestions.shadowColor.a,
              }}
              onChangeComplete={(color) => {
                handleUpdate("shadowColor", {
                  r: color.rgb.r,
                  g: color.rgb.g,
                  b: color.rgb.b,
                  a: color.rgb.a,
                });
              }}
            />
          </ColorPickerWrapper>
        </SettingRow>

        <SettingRow>
          <Label>Padding Vertical (px)</Label>
          <Wrapper>
            <Input
              type="number"
              value={suggestions.paddingVertical}
              onChange={(e) =>
                handleUpdate("paddingVertical", parseInt(e.target.value) || 8)
              }
              min={0}
              max={30}
            />
            <span>{suggestions.paddingVertical}px</span>
          </Wrapper>
          <Slider
            value={suggestions.paddingVertical}
            onChange={(val) => handleUpdate("paddingVertical", val)}
            min={0}
            max={30}
            step={1}
            style={{ marginTop: "8px" }}
          />
        </SettingRow>

        <SettingRow>
          <Label>Padding Horizontal (px)</Label>
          <Wrapper>
            <Input
              type="number"
              value={suggestions.paddingHorizontal}
              onChange={(e) =>
                handleUpdate("paddingHorizontal", parseInt(e.target.value) || 12)
              }
              min={0}
              max={30}
            />
            <span>{suggestions.paddingHorizontal}px</span>
          </Wrapper>
          <Slider
            value={suggestions.paddingHorizontal}
            onChange={(val) => handleUpdate("paddingHorizontal", val)}
            min={0}
            max={30}
            step={1}
            style={{ marginTop: "8px" }}
          />
        </SettingRow>

        <SettingRow>
          <Label>Enable Hover Animation</Label>
          <Switch
            checked={suggestions.enableHoverAnimation}
            onChange={(checked) => handleUpdate("enableHoverAnimation", checked)}
          />
        </SettingRow>

        {suggestions.enableHoverAnimation && (
          <SettingRow>
            <Label>Hover Scale</Label>
            <Wrapper>
              <Input
                type="number"
                value={suggestions.hoverScale}
                onChange={(e) =>
                  handleUpdate("hoverScale", parseFloat(e.target.value) || 1.02)
                }
                min={1}
                max={1.2}
                step={0.01}
              />
              <span>{(suggestions.hoverScale * 100).toFixed(0)}%</span>
            </Wrapper>
            <Slider
              value={Math.round((suggestions.hoverScale - 1) * 1000)}
              onChange={(val) => {
                const numVal = typeof val === "number" ? val : val[0];
                handleUpdate("hoverScale", 1 + numVal / 1000);
              }}
              min={0}
              max={200}
              step={1}
              style={{ marginTop: "8px" }}
            />
          </SettingRow>
        )}
      </Panel>
    </Collapse>
  );
}
